/* unplugin-vue-components disabled */import script from "./index.vue?vue&type=script&setup=true&name=video&lang=js"
export * from "./index.vue?vue&type=script&setup=true&name=video&lang=js"

import "./index.vue?vue&type=style&index=0&id=61e959c4&lang=scss&scoped=true"

import exportComponent from "E:\\new-admin\\3.0\\ruoyi-vue3-cli\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61e959c4"]])

export default __exports__